<div class="container">
    <div mat-dialog-title>
        <p>{{ product.Name }}</p>
    </div>
    <div mat-dialog-content>
        <mat-tab-group mat-align-tabs="center" animationDuration="1ms">
            <mat-tab label="Wszyskie SKU">
                <pr-product-logics-modal-browser-new
                    [dataService]="dataService"
                    [selectedData]="products"
                    [columnsData]="columnsData"
                    [dataServiceMethod]="'fetchProductLogicsData'"
                    [originProducts]="originProducts"
                    (selectedRows)="addNewRow($event)"
                    [tableId]="tableId"
                ></pr-product-logics-modal-browser-new>
<!--                <product-logics-modal-browser-->
<!--                    (addRow)="addNewRow($event)"-->
<!--                    [selectedData]="products"-->
<!--                    [originProducts]="originProducts"-->
<!--                ></product-logics-modal-browser>-->
            </mat-tab>
            <mat-tab label="Edycja wybranych SKU">
                <div fxLayout="column">
                    <div class="pv-xxs">
                        <p>- Uzupełnij Współczynik Powiązania wartością w zakresie 0.00 - 10,000.00</p>
                        <p>- Indeks min oraz Indeks max możesz uzupełnić wartością 0.00 - 300.00. Pamiętaj, że Indeks min musi być mniejszy od Indeks max.</p>
                        <p>- Uzupełnij Nazwy Powiązania.</p>
                    </div>
                    <pr-product-logics-modal-summary-new
                        [columnsData]="unselectColumnsData"
                        [tableData]="products"
                        (removeProduct)="deleteSelected($event)"
                        [tableId]="unselectTableId"
                    ></pr-product-logics-modal-summary-new>
                </div>
            </mat-tab>
        </mat-tab-group>
    </div>
    <div mat-dialog-actions>
        <button type="button"
            class="upper ml-xxs action-button butt-back action-button-icon"
            (click)="closeModal(false)"
            [disabled]="startEdition"
        >
            <p class="upper">wróć</p>
            <mat-icon class="action-icon">keyboard_return</mat-icon>
        </button>
        <button type="button"
            class="upper ml-xxs action-button butt-primary action-button-icon"
            [disabled]="startEdition"
            (click)="save()"
        >
            <p class="upper">zapisz</p>
            <mat-icon class="action-icon">save_alt</mat-icon>
        </button>
        <button-spinner class="ml-xxs" [inProgress]="startEdition" diameter="20">
        </button-spinner>
    </div>
</div>

<style>
    .conf-dialog-caption {
        font-size: 13px;
    }

    /* add content height */
    ::ng-deep .mat-dialog-content {
        height: 500px;
    }
    /* add flex to spread table*/
    ::ng-deep .mat-tab-body-content {
        display: flex;
        flex-grow: 1;
    }
    /* override color */
    ::ng-deep .mat-tab-group.mat-primary .mat-ink-bar,
    ::ng-deep .mat-tab-nav-bar.mat-primary .mat-ink-bar {
        background-color: var(--primary);
    }

    .mat-dialog-title {
        margin: 0;
    }

    .mat-dialog-title p {
        font-size: 16px;
    }
</style>
